module.exports = __webpack_public_path__ + "wxMicroService/img/positive.bbba50c7.png";